module.exports = __webpack_public_path__ + "static/media/blank.e11a302e.jpg";